class ReferenceOptionsCtrl {
  constructor($uibModal, $scope, TemplateService, EventService, SchemaService, AuthService, TBService) {
    'ngInject';
    Object.assign(this, { $uibModal, $scope });
    this.ts = TemplateService;
    this.es = EventService;
    this.ss = SchemaService;
    this.as = AuthService;
    this.tbs = TBService;

    this.loading = "Loading Tables..";
    this.selectedReference = null;
    this.uploadFields = [];
    this.redirectFields = [];
    this.successMessageFields = [];
    this.passkeyFields = [];
    this.filenameFields = [];
    this.fileUploadLabel = '';
    this.showUploadConfig = false;
    this.uploadExtensions = [{text: 'Adobe (.pdf)', value: ''}, {text: 'MS Word (.docx)', value: 'docx'}, {text: 'PowerPoint (.pptx)', value: 'pptx'}, {text: 'Image (.jpg)', value: 'jpg'}];
    this.messages = [];
    this.addRelModal = {};
    this.missingField = { label: '[MISSING]', type: 'unknown' };

    this.formActions = [
      { type: "submit", title: "Submit"},
      { type: "update", title: "Update"},
      { type: "print", title: "Print"}];
    this.refColumns = [
      {
        'key': 'id',
        'header': " ",
        'style': { 'width': '25px', 'padding': '8px', 'overflow': 'initial'},
        'format': value => `<i class="fa fa-eye"/>`
      },
      {
        'key': 'name',
        'header': "Name",
        'tooltip': true,
      },
      {
        'key': 'id',
        'header': "Fields",
        'style': { 'width': '60px', 'max-width': '60px'  },
        'format': value => this.ts.tokens.filter(f => f.referenceId === value).length
      },
      {
        'key': 'id',
        'header': 'Upload',
        'style': { },
        'format': (value, format, record) => this.tbs.getRefUploadFieldConfig(this.ts.template, record, this.PROVIDER, false).label,
        'tooltip': true,
      },
      {
        'key': 'id',
        'header': 'Related to',
        'format': value => this.getRelations(value),
        'tooltip': true,
      }
    ];

  }

  async $onInit() {
    this.td = await this.ts.getTemplateData();
    this.templateId = this.ts.templateId;
    this.isDynamic = this.td.template.type === 'dynamic';
    this.title = this.td.template.title;
    this.PROVIDER = await this.as.getProviderSettings();

    this.tokenColumns = [
      {
        'key': 'fieldId',
        'header': " ",
        'sortable': true,
        'style': { 'width': '25px', 'padding': '8px', 'overflow': 'initial'},
        'format': value => `<i class="fa fa-eye"/>`
      },
      {
        'key': 'label',
        'header': "Label",
        'sortable': true
      },
      {
        'key': 'type',
        'header': "Type",
        'sortable': true,
        'style': {"text-transform": "capitalize"}
      },
      {
        'key': 'fieldId',
        'header': "Field ID",
        'sortable': true,
        'style': {"text-transform": "capitalize"}
      }
      
    ];
    if (!this.isDynamic) {
      this.tokenColumns.push(
        {
          'key': 'pageNumber',
          'header': "Page",
          'sortable': true
        }
      );
    }

    this.loading = "";

    if (this.td.template.signTemplate) {
      this.refColumns = this.refColumns.filter((col) => col.header !== 'Upload');
    }

    this.setActiveReference();
  }

  setActiveReference() {
    const activeReference = this.referenceId ? this.ts.references.find(r => r.id === this.referenceId): null;
    if (activeReference) {
      this.referenceSelected(activeReference);
      this.showUploadConfig = true;
    }
  }

  getFieldById(fieldId) {
    return this.selectedReference.tableSchema?.fields?.find(f => f.id == fieldId);
  }

  setConfigField(fieldName, value, clear = false) {
    if (clear) this.ts.references.forEach(ref => delete ref[fieldName]);
    if (value !== null) { this.selectedReference[fieldName] = value }
    else { delete this.selectedReference[fieldName] }
    if (fieldName === 'passkeyFID' && value === null) delete this.selectedReference.passkeyPlaceholder;
    this.updateTemplateReferenceData();
  }

  updateTemplateReferenceData() {
    this.ts.notifyUpdate(["references"], this.td);
  }
  
  setMsg(message, type, closeInSeconds) {
    this.messages = [{ message, "class": type, closeInSeconds }];
  }

  referenceSelected(record, index) {
    this.selectedReference = record;
    this.selectedReference.link = this.PROVIDER.tableLinkTemplate
      .replace('[REALM]', this.td.template.realm)
      .replace('[TABLE_ID]', this.selectedReference.tableId);

    this.referenceTokens = this.ts.tokens.filter(t => t.referenceId === record.id).map(
      token => ({
        fieldId: token.fieldId,
        referenceId: token.referenceId,
        label: token.fieldSchema?.label,
        type: token.control.type.split("-").slice(0, -1).join(" "),
        tokenId: token.id,
        pageNumber: this.isDynamic ? 0 : this.td.template.partialPages.find(p => p.id == token.pageId).pageNumber,
        pageId: this.isDynamic ? null : token.pageId,
        ... token.fieldSchema ? {} : this.missingField }))
      .sort((a, b) => a.pageNumber !== b.pageNumber ? a.pageNumber - b.pageNumber : a.label.localeCompare(b.label));

    this.uploadFields = this.tbs.getRefUploadFields(this.ts.template, record, this.PROVIDER);
    this.redirectFields = this.tbs.getRedirFields(record, this.PROVIDER);
    this.successMessageFields = this.tbs.getSuccessMsgFields(record, this.PROVIDER);
    this.passkeyFields = this.tbs.getPasskeyFields(record, this.PROVIDER);
    this.filenameFields = this.tbs.getRefFilenameFields(record, this.PROVIDER);
    this.fileUploadLabel = this.tbs.getRefUploadFieldConfig(this.ts.template, record, this.PROVIDER, true).label;
  }

  tokenSelected(record, _index) {
    this.onCancel();
    this.es.dispatchEvent(
      this.es.actions.TOKEN_SELECTED, 
      { id: record.tokenId, referenceId: record.referenceId, pageId: record.pageId });
  }

  getRelations(refId) {
    if (!refId || !this.ts.references?.length || !this.ts.relations?.length) return "None";

    const parents = this.ts.relations.filter(rel => rel.parentId === refId).map(p => {
      const childName = this.ts.references.find(ref => ref.id === p.childId).name;
      return `Many ${childName}`;
    });
    const children = this.ts.relations.filter(rel => rel.childId === refId).map(c => {
      const parentName = this.ts.references.find(ref => ref.id === c.parentId).name;
      return `A ${parentName}`;
    });
    return [...new Set([...parents, ...children])].join("\n");
  }

  checkboxChanged() {
    this.updateTemplateReferenceData();
  }

  templatePropChanged(prop) {
    this.ts.notifyUpdate([prop], this.td);
  }

  async openParentChild() {
    this.addRelModal = this.$uibModal.open({
      template: `<parent-child
                  on-cancel="$ctrl.closeParentChild()">
                </parent-child>`,
      windowClass: 'parent-child-modal',
      scope: this.$scope
    });
    this.addRelModal.result.then(
      closed => true,
      canceled => this.cancel()
    );
  }

  closeParentChild() {
    this.addRelModal.dismiss("Canceled");
  }

  cancel() {
  }

  collapseGroupPanels(group) {
    $(`${group} .panel-collapse`).collapse('hide');
  }

}

export default {
  bindings: {
    referenceId: "=?",
    onCancel: "&"
  },
  templateUrl: "form-builder/reference-options/reference-options.component.html",
  controller: ReferenceOptionsCtrl
};
